import { Component, Input, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormFieldOption } from '../../../dto/util/form-field';
import { LoginResponseDto } from '../../../dto/auth/login-response.dto';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';
import { AutenticacionService } from '../services/autenticacion.service';
import { RecaptchaService } from '../../../services/util/recaptcha.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { NotificationService } from '../../../services/notification.service';
import { UtilService } from '../../../services/util.service';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { UsuarioService } from '../../../services/usuario.service';
import { FuncionalidadService } from '../../../services/funcionalidad.service';
import { SocketService } from '../../../services/socket.service';
import { ProcessService } from '../../../services/process.service';
import { EntidadService } from '../../../services/entidad.service';
import { Constants } from '../../../constants/constants';
import { ModalDobleFactorComponent } from '../modal-doble-factor/modal-doble-factor.component';
import { ModalTipoUsuarioComponent } from '../modal-tipo-usuario/modal-tipo-usuario.component';
import { ModalRestablecerContraseniaComponent } from '../modal-restablecer-contrasenia/modal-restablecer-contrasenia.component';
import { Location } from '@angular/common';
import { EmpresaService } from '../services/empresa.service';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {EmpresaGestorDTO, ObtenerEmpresasGestorDTO} from "../../empresas/models/gestorDTO";
import {UsuariosGestoresService} from "../../../services/empresas/usuarios-gestores.service";

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrl: './login-admin.component.scss',
})
export class LoginAdminComponent {
  isSecure = environment.esHttps;
  @ViewChild(ModalDobleFactorComponent)
  ModalDobleFactorComponent!: ModalDobleFactorComponent;
  @ViewChild(ModalTipoUsuarioComponent)
  ModalTipoUsuarioComponent!: ModalTipoUsuarioComponent;
  @ViewChild(ModalRestablecerContraseniaComponent)
  ModalRestablecerContraseniaComponent!: ModalRestablecerContraseniaComponent;
  @Input() isFuncionario: boolean = true;
  public loginForm!: FormGroup;
  public loginFormEmpresa!: FormGroup;

  openModalDobleFactorAutenticacion = false;
  openModalTipoUsuario = false;
  tiposUsuario: FormFieldOption[] = [];
  tipoUsuarioSeleccionado = 0;
  loginResponse?: LoginResponseDto;
  usuarioId?: number = 0;
  showPassword = false;
  URL_LOGIN = `${environment.AUTH_FRONT}/auth/sign-in?entidadId=${environment.ID_ENTITY}`;

  entidadJustifacil: EntidadDto = {
    id: 0,
    entidad: '',
  };

  // Variable para modal olvido contraseña
  openModalFPassword: boolean = false;

  loginText: any = {};

  constructor(
    private fb: FormBuilder,
    private authService: AutenticacionService,
    private recaptchaService: RecaptchaService,
    private alertaModalService: AlertaModalService,
    private notificationService: NotificationService,
    private utilService: UtilService,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private usuarioService: UsuarioService,
    private funcionalidadService: FuncionalidadService,
    private socketService: SocketService,
    private processService: ProcessService,
    private entidadService: EntidadService,
    private location: Location,
    private empresaService: EmpresaService,
    private readonly translate: TranslateService,
    private usuariosGestoresService: UsuariosGestoresService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      if (navigation.extras.state['loginEmpresa']) {
        this.isFuncionario = false;
      }
    }
    this.buildForm();
    this.authService.logout();
    this.entidadService.obtenerEntidadJustifacil().subscribe(response => {
      this.entidadJustifacil = response;
    });
    combineLatest({
      loginAdmin: this.translate.stream('login-admin'),
    }).subscribe(({ loginAdmin }) => {
      // Asignar traducciones a variables
      this.loginText = loginAdmin;
    });
  }

  buildForm() {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.maxLength(50)]],
      contrasena: ['', [Validators.required, Validators.maxLength(100)]],
    });
    this.loginFormEmpresa = this.fb.group({
      username: ['', [
        Validators.required,
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        Validators.maxLength(100)]],
      contrasena: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }

  // Método para manejar el evento input
  onInputChange(event: any, maxLength: number, nombreInput: string) {
    const input = event.target as HTMLInputElement;

    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
      this.loginForm.get(nombreInput)?.setValue(input.value);
    }
  }

  onInputChangeEmpresa(event: any, maxLength: number, nombreInput: string) {
    const input = event.target as HTMLInputElement;

    // Guardar posición actual del cursor
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    // Transformar valor a mayúsculas
    let value = input.value.toUpperCase();

    // Respetar maxLength
    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    // Solo actualizar si cambia (evita reseteos innecesarios)
    if (input.value !== value) {
      input.value = value;
      this.loginFormEmpresa.get(nombreInput)?.setValue(value);

      // Restaurar la posición del cursor
      setTimeout(() => {
        input.setSelectionRange(start, end);
      }, 0);
    }
  }

  onRecaptchaResolved(token: string | null) {
    this.recaptchaService
      .verificarTokenRecaptcha({ token: token! })
      .subscribe(response => {
        if (!response.success) {
          this.loginForm.get('captcha')?.patchValue('success');
        } else {
          this.loginForm.get('captcha')?.patchValue(null);
        }
      });
  }

  onSubmit(action: string) {
    if (environment.esLaboratorio === 'true') {
      window.location.href = this.URL_LOGIN;
    } else {
      const loginRequest = this.loginForm.value;
      this.recaptchaV3Service.execute(action).subscribe((token: string) => {
        this.recaptchaService
          .verificarTokenRecaptcha({ token: token })
          .subscribe(
            response => {
              if (response.success == true) {
                this.authService.login(loginRequest).subscribe(
                  response => {
                    if (response.status == 'SUCCESS') {
                      if (response.access_token == undefined) {
                        this.usuarioId = response.usuario?.idUsuario;
                        this.abrirModalDobleFactorAutenticacion();
                      } else {
                        this.loginResponse = response;

                        if (
                          response.usuario?.fechaHoraPrimerIngreso ||
                          response.usuario?.tipoUsuario?.Id == Constants.TIPO_PERSONA.NATURAL ||
                          response.usuario?.tipoUsuario?.Id == Constants.TIPO_PERSONA.JURIDICA
                        ) {
                          this.consultarTiposUsuario(
                            this.loginResponse.usuario?.idUsuario
                          );
                        } else {
                          this.router.navigateByUrl(
                            // 'cambiar-contrasenia/' + response.access_token
                            'cambiar-contrasenia'
                          );
                          this.utilService.setCookie(
                            Constants.MDJ_ACCESS_TOKEN,
                            response.mdj_auth
                          );
                        }
                      }
                    } else {
                      this.alertaModalService.error(`${response.message}`);
                    }
                  },
                  err => {
                    const resp = JSON.parse(err.error.message);
                    this.alertaModalService.error(
                      this.loginText['error-auth'],
                      resp.error
                    );
                  }
                );
              } else {
                this.alertaModalService.error(
                  'Validación de recaptcha erronea',
                  'La validación de captcha no pudo ser completada.'
                );
              }
            },
            () => {
              this.alertaModalService.error(
                'Validación de recaptcha erronea',
                'La validación de captcha no pudo ser completada.'
              );
            }
          );
      });
    }
  }

  async onSubmitEmpresa() {
    const json = {
      username: this.loginFormEmpresa.get('username')?.value,
      contrasena: this.loginFormEmpresa.get('contrasena')?.value
    }
    this.empresaService.autenticacionEmpresa(json).subscribe((response: any) => {
      this.loginResponse = response;
      this.consultaTipoEmpresa(this.loginResponse?.usuario?.idUsuario)
    },
      err => {
        this.alertaModalService.error(
          this.loginText['error-auth']
        );
      });
  }

  loginCorrecto(response: LoginResponseDto) {
    sessionStorage.setItem(
      Constants.USER_INFORMATION_STORAGE,
      JSON.stringify(response.usuario)
    );
    localStorage.setItem(
      Constants.USER_INFORMATION_STORAGE,
      JSON.stringify(response.usuario)
    );
    sessionStorage.setItem(Constants.IS_SUCCESS_LOGIN, '1');
    localStorage.setItem(Constants.IS_SUCCESS_LOGIN, '1');
    if (!this.isSecure) {
      sessionStorage.setItem(Constants.ACCESS_TOKEN, response.access_token);
      sessionStorage.setItem(Constants.REFRESH_TOKEN, response.refresh_token);
    }

    let token = response.access_token;

    this.utilService.setCookie(Constants.MDJ_ACCESS_TOKEN, response.mdj_auth);
    this.utilService.showNavUser();
    this.authService.executeRefreshToken(token);

    sessionStorage.setItem(
      Constants.USER_DOCUMENT_TYPE,
      response.usuario?.tipoDocumento ?? ''
    );
    localStorage.setItem(
      Constants.USER_DOCUMENT_TYPE,
      response.usuario?.tipoDocumento ?? ''
    );
    sessionStorage.setItem(
      Constants.USER_IDENTIFICATION,
      response.usuario?.identificacion ?? ''
    );
    localStorage.setItem(
      Constants.USER_IDENTIFICATION,
      response.usuario?.identificacion ?? ''
    );
    if (
      response.usuario?.tipoDocumento &&
      response.usuario?.idTipoDocumento &&
      response.usuario?.identificacion &&
      response.usuario?.idUsuario &&
      response.usuario?.tipoUsuario?.Rol_Externo !== Constants.ROL_EXTERNO_EMPRESA
    ) {
      this.startUserProcess(
        response.usuario.identificacion,
        response.usuario.tipoDocumento,
        response.usuario.idTipoDocumento,
        response.usuario.idUsuario,
        response.usuario.tipoUsuario?.Id ?? 0
      );
    }
  }

  abrirModalDobleFactorAutenticacion() {
    this.openModalDobleFactorAutenticacion = true;
    setTimeout(() => {
      this.ModalDobleFactorComponent.abrirCerrarModal();
    }, 500);
  }

  abrirModalTipoUsuario() {
    this.openModalTipoUsuario = true;
    setTimeout(() => {
      this.ModalTipoUsuarioComponent.abrirCerrarModal();
    }, 500);
  }

  verificarDobleFactor(response: any | boolean) {
    if (!response) {
      this.alertaModalService.error(
        Constants.ERROR_VALIDANDO,
        Constants.CODIGO_NO_SATISFACTORIO
      );
    } else {
      this.loginResponse = response as LoginResponseDto;
      this.ModalDobleFactorComponent.abrirCerrarModal();
      if (
        response.usuario?.fechaHoraPrimerIngreso ||
        response.usuario?.tipoUsuario?.Id == Constants.TIPO_PERSONA.NATURAL ||
        response.usuario?.tipoUsuario?.Id == Constants.TIPO_PERSONA.JURIDICA
      ) {
        this.consultarTiposUsuario(response.usuario.idUsuario);
      } else {
        if (this.isSecure) {
          this.router.navigateByUrl(
            // 'cambiar-contrasenia/' + response.access_token
            'cambiar-contrasenia'
          );
        } else {
          this.router.navigateByUrl(
            'cambiar-contrasenia/' + response.access_token
          );
        }
        this.utilService.setCookie(
          Constants.MDJ_ACCESS_TOKEN,
          response.mdj_auth
        );
      }
    }
  }

  async consultarTiposUsuario(usuarioId?: number) {
    return this.usuarioService.consultarTiposUsuario(usuarioId!).subscribe({
      next: resp => {
        if (resp.tiposUsuario.length == Constants.TIPO_PERSONA.NATURAL) {
          this.tipoUsuarioSeleccionado = resp.tiposUsuario[0].Id;
          sessionStorage.setItem(
            Constants.USER_TYPE,
            JSON.stringify({
              Id: resp.tiposUsuario[0].Id,
              Nombre: resp.tiposUsuario[0].Tipo_Usuario,
              Id_Entidad: resp.tiposUsuario[0].Id_Entidad,
              Rol_Externo: resp.tiposUsuario[0].Rol_Externo,
            })
          );
          this.utilService.setRole(resp.tiposUsuario[0].Tipo_Usuario || null);
          this.loginCorrecto(this.loginResponse!);
          this.consultarFuncionalidades();
        } else {
          this.tiposUsuario = resp.tiposUsuario.map(tipo => {
            return {
              Id: tipo.Id,
              Nombre: tipo.Tipo_Usuario,
              Id_Entidad: tipo.Id_Entidad,
              Rol_Externo: tipo.Rol_Externo,
              selected: false,
            };
          });
          this.enriquecerRolesGestor();

          this.openModalTipoUsuario = true;
          this.abrirModalTipoUsuario();
        }
      },
    });
  }

  async consultarFuncionalidades() {
    let token;
    if (!this.isSecure) {
      token = this.loginResponse?.access_token;
    }
    return this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuario(this.tipoUsuarioSeleccionado, token)
      .subscribe({
        next: response => {
          sessionStorage.setItem(
            Constants.FUNCIONALIDADES,
            JSON.stringify(response)
          );
          localStorage.setItem(Constants.FUNCIONALIDADES,
            JSON.stringify(response));
          this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_CIUDADANO ||
            this.tipoUsuarioSeleccionado === Constants.ID_TIPO_USUARIO_ABOGADO
            ? this.router.navigateByUrl('procesos/resumen')
            : this.router.navigateByUrl(response[0]?.url || '/');
        },
      });
  }

  consultaTipoEmpresa(usuarioId?: number) {
    return this.usuarioService.consultarTiposUsuario(usuarioId!).subscribe({
      next: resp => {
        sessionStorage.setItem(
          Constants.USER_TYPE,
          JSON.stringify({
            Id: resp.tiposUsuario[0].Id,
            Nombre: resp.tiposUsuario[0].Tipo_Usuario,
            Id_Entidad: resp.tiposUsuario[0].Id_Entidad,
          })
        );
        this.utilService.setRole(resp.tiposUsuario[0].Tipo_Usuario || null);
        this.loginCorrecto(this.loginResponse!);
        this.consultarFuncionalidadesEmpresa(this.loginResponse?.usuario?.tipoUsuario?.Id);
      },
    });
  }

  async consultarFuncionalidadesEmpresa(tipoUsuarioId?: number) {
    console.log('[consultarFuncionalidadesEmpresa] Iniciando...');
    console.log('Tipo Usuario ID:', tipoUsuarioId);
    console.log('Es HTTPS:', this.isSecure);

    let token;
    if (!this.isSecure) {
      token = this.loginResponse?.access_token;
    }

    console.log('Token a pasar al servicio:', token);
    console.log('loginResponse completo:', this.loginResponse);

    return this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuarioEmpresa(tipoUsuarioId!, token)
      .subscribe({
        next: response => {
          console.log('Funcionalidades cargadas:', response);

          if (!response || response.length === 0) {
            console.warn('No se encontraron funcionalidades');
            this.alertaModalService.error(
              'Sin funcionalidades',
              'No se encontraron funcionalidades asignadas. Contacte al administrador.'
            );
            this.authService.logout();
            this.router.navigate(['/login']);
            return;
          }

          sessionStorage.setItem(
            Constants.FUNCIONALIDADES,
            JSON.stringify(response)
          );
          localStorage.setItem(
            Constants.FUNCIONALIDADES,
            JSON.stringify(response)
          );

          console.log('Navegando a: empresa/gestion-usuarios');
          this.router.navigateByUrl('empresa/gestion-usuarios');
        },
        error: (err) => {
          console.error('Error cargando funcionalidades:', err);
          console.error('Status:', err.status);
          console.error('URL:', err.url);
          console.error('Error body:', err.error);

          if (err.status === 401) {
            this.alertaModalService.error(
              'Error de autenticación',
              'No se pudo autenticar. Por favor, intente nuevamente.'
            );
            this.authService.logout();
            this.router.navigate(['/login']);
          } else {
            this.alertaModalService.error(
              'Error al cargar funcionalidades',
              err.error?.message || 'No se pudieron cargar los permisos del usuario'
            );
          }
        }
      });
  }

  obtenerTipoUsuario(tipoUsuarioSeleccionado: number) {
    this.tipoUsuarioSeleccionado = tipoUsuarioSeleccionado;
    let selected = this.tiposUsuario.find(
      tipo => tipo.Id == tipoUsuarioSeleccionado
    );
    sessionStorage.setItem(Constants.USER_TYPE, JSON.stringify(selected));
    this.utilService.setRole(selected?.Nombre || null);
    this.consultarFuncionalidades();
    this.loginCorrecto(this.loginResponse!);
    this.ModalTipoUsuarioComponent.abrirCerrarModal();
  }

  private startUserProcess(
    numeroIdentificacion: string,
    tipoIdentificacion: string,
    idTipoDocumento: number,
    idUsuario: number,
    idTipoUsuario: number
  ): void {
    if (!numeroIdentificacion || !tipoIdentificacion) {
      this.notificationService.addNotification(
        'error',
        'Número de identificación o tipo de identificación no definidos'
      );
      return;
    }

    const userInfo = this.loginResponse?.usuario;
    const rolExterno = userInfo?.tipoUsuario?.Rol_Externo;

    console.log('startUserProcess - Rol detectado:', rolExterno);

    if (rolExterno === Constants.ROL_EXTERNO_GESTOR_EMPRESA) {
      const userTypeString = sessionStorage.getItem(Constants.USER_TYPE);

      if (userTypeString) {
        const selectedRole = JSON.parse(userTypeString);

        if (selectedRole.empresaInfo) {
          console.log(`Sincronizando para empresa: ${selectedRole.empresaInfo.razonSocial} (${selectedRole.empresaInfo.nit})`);

          this.processService
            .sincronizarExpedientes(
              selectedRole.empresaInfo.nit,
              selectedRole.empresaInfo.tipoDocumento,
              selectedRole.empresaInfo.idTipoDocumento,
              idUsuario,
              idTipoUsuario
            )
            .subscribe({
              next: () => {
                this.notificationService.addNotification(
                  'success',
                  `Sincronización iniciada para ${selectedRole.empresaInfo.razonSocial}`
                );
              },
              error: () => {
                this.notificationService.addNotification(
                  'error',
                  `Error al sincronizar expedientes de ${selectedRole.empresaInfo.razonSocial}`
                );
              },
            });
        } else {
          console.warn('El rol de gestor no tiene información de empresa asociada');
        }
      }
    } else {
      // Flujo original para otros roles
      this.processService
        .sincronizarExpedientes(
          numeroIdentificacion,
          tipoIdentificacion,
          idTipoDocumento,
          idUsuario,
          idTipoUsuario
        )
        .subscribe({
          next: () => {
            this.notificationService.addNotification(
              'success',
              'Sincronización de expedientes iniciada exitosamente'
            );
          },
          error: () => {
            this.notificationService.addNotification(
              'error',
              'Error al sincronizar expedientes'
            );
          },
        });
    }

    const cambiosExpedientes: { radicado: string; action: string }[] = [];
    let timeout: any = null;

    this.socketService.listenToExpedienteChanges((data: any) => {
      cambiosExpedientes.push(data);

      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        if (cambiosExpedientes.length > 0) {
          const creados = cambiosExpedientes
            .filter(item => item.action === 'created')
            .map(item => item.radicado)
            .join(', ');

          const actualizados = cambiosExpedientes
            .filter(item => item.action === 'updated')
            .map(item => item.radicado)
            .join(', ');

          if (creados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido creados: ${creados}`
            );
          }
          if (actualizados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido actualizados: ${actualizados}`
            );
          }

          cambiosExpedientes.length = 0;
          timeout = null;
        }
      }, 3000);
    });
  }

  openModalContrasenia() {
    this.openModalFPassword = true;
    setTimeout(() => {
      this.ModalRestablecerContraseniaComponent.abrirCerrarModal();
    }, 100);
  }

  goBack() {
    this.location.back();
  }

  private enriquecerRolesGestor(): void {
    const rolesGestor = this.tiposUsuario.filter(
      (rol: any) => rol.Rol_Externo === Constants.ROL_EXTERNO_GESTOR_EMPRESA
    );

    if (rolesGestor.length > 0 && this.loginResponse?.usuario?.idPersona) {
      this.usuariosGestoresService
        .obtenerEmpresasPorGestor(this.loginResponse.usuario.idPersona)
        .subscribe({
          next: (response: ObtenerEmpresasGestorDTO) => {
            if (response.data.tieneEmpresas && response.data.empresas.length > 0) {
              // Asociar cada rol de gestor con su empresa correspondiente
              rolesGestor.forEach((rol: any) => {
                const empresa = response.data.empresas.find(
                  (emp: EmpresaGestorDTO) => rol.Nombre.includes(emp.razonSocial)
                );

                if (empresa) {
                  // Agregar información de la empresa al rol
                  rol.empresaInfo = {
                    nit: empresa.nit,
                    razonSocial: empresa.razonSocial,
                    tipoDocumento: empresa.tipoDocumento,
                    idTipoDocumento: empresa.idTipoDocumento,
                  };
                }
              });

              console.log('Roles enriquecidos con info de empresa:', this.tiposUsuario);
            }
          },
          error: err => {
            console.error('Error al enriquecer roles con empresas:', err);
          },
        });
    }
  }
}
